import React from 'react';
import { Form, Modal, Checkbox, Segment, Label, Button } from 'semantic-ui-react';
import { BaseURLDev, headers } from '../../../../../_utils/config';
import swal from 'sweetalert'

export default class ModalEdit extends React.Component {
   constructor(props){
      super(props);
      this.state = {
         data:{
               alamat: props.data.alamat,
               nama: props.data.nama,
               jabatan:props.data.jabatan,
               kode: props.data.kode,
               contact: props.data.contact,
               // is_active:props.data.is_active
            },

         loading:false,

      }

      this.onChange = this.onChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      // this.toggleActive = this.toggleActive.bind(this);
      this.handleKeyPress = this.handleKeyPress.bind(this)
   }

   handleKeyPress(event){
      if(event.key === '/' || event.key === '%' || event.key === "'" || event.key === '"'){
         swal("Maaf, penggunaan spesial karakter (\", ', %, /) pada isian nama atau keterangan diblock", {
            icon: "warning",
         });
      }
   }

   // toggleActive = () => this.setState({data:{...this.state.data,is_active:!this.state.data.is_active}})

   onSubmit(e){
      const { kode, nama, jabatan } = this.state.data;
      e.preventDefault();
      if((kode===null || kode==="") || (nama===null || nama==="") || (jabatan===null || jabatan==="")){
         swal("Kolom NIP/Nama/Jabatan mohon diisi",{icon:'error'})
      }else{
         this.setState({loading:true});
         e.preventDefault();
         fetch(`${BaseURLDev}/paraf/${this.props.data.id}`,{
            method: 'PUT',
            headers,
            body: JSON.stringify(this.state.data)
         })
         .then(response => {
            if (!response.ok) { 
               swal("", "Update data Pejabat Paraf gagal", "error");
               this.setState({loading:false,error:true});
               return Promise.reject(response.statusText);
            }
            else{
               swal("Update data Pejabat Paraf selesai",{icon:"success"}).then(()=>{
                  window.location.href = '/b/paraf';
               })
               //swal("Update data pegawai selesai",{icon:'success'})
               // window.location.href = '/b/paraf'
            }
         })
      }
   }

   onChange(e){
      let text = e.target.value.replace(/['/%"]/g, '')
      this.setState({data:{...this.state.data, [e.target.name]:text}});
   }

   render() {

      const {nama,jabatan,kode,alamat,contact} = this.state.data;
      const {loading} = this.state;

      return (
      <div>
         <Modal
               open={this.props.open}
               onClose={this.props.onClose}
               closeOnEscape={false}
               closeOnRootNodeClick={false}
               size="small"
            >
               <Modal.Header>
                  Edit data pejabat/pegawai
               </Modal.Header>
               
               <Modal.Content scrolling>
                  <Segment padded>
                     <Label attached='top' color="violet">Form edit data Pejabat/Pegawai Bendahara Penerima</Label>
                     <Form onSubmit={this.onSubmit} loading={loading}>              
                        <Form.Input value={kode} onKeyPress={this.handleKeyPress} onChange={this.onChange} name="kode" placeholder="NIP/Kode Pegawai"/>
                        <Form.Input value={nama} onKeyPress={this.handleKeyPress} onChange={this.onChange} name="nama" placeholder='Nama pegawai' />               
                        <Form.Input value={jabatan} onKeyPress={this.handleKeyPress} onChange={this.onChange} name="jabatan" placeholder='Jabatan pegawai' />               
                        <Form.Input value={contact} onKeyPress={this.handleKeyPress} onChange={this.onChange} name="contact" placeholder='Nomor contact' />               
                        <Form.TextArea value={alamat} onKeyPress={this.handleKeyPress} onChange={this.onChange} placeholder='Alamat pegawai' name="alamat" />
                        {/* <Checkbox 
                           label="*Status pegawai/pejabat aktif/tidak"
                           onChange={this.toggleActive} 
                           checked={is_active} /><br /><br />
                         */}
                        <Form.Button positive>Perbaharui</Form.Button>
                     </Form>
                  </Segment>
               </Modal.Content>
               <Modal.Actions>
                  <Button negative onClick={this.props.onClose}>Tutup</Button>                        
               </Modal.Actions>
            </Modal>                      
      </div>
      );
   }
}


// WEBPACK FOOTER //
// ./src/components/Content/views/opd/_paraf/ModalEdit.js